<template>
  
  <a-card :bordered='false'>
    <SmallSquare class="m-b-20" content='1、开通的商户必须是依法在中国大陆注册的企业或个体工商户，须持有商标或商标授权书，为了您能正常使用功能，请先完成企业资质和商标资质认证。
    2、所有提交的资质证书需为清晰彩色原件扫描件，复印件则需加盖公司红章，我们将在三个工作日内完成认证。' :padding='false' />
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='cert_name' :columns='columns' :data-source='data'>
        <template v-slot:action="{ record }">
          <a-button type="primary" v-if='record.status == -1' v-has:qualifiedSubmit='()=>submit(record)'>提交</a-button>
          <a-button type="primary" v-else v-has:qualifiedSubmit='()=>update(record)'>更新</a-button>
        </template>
      </a-table>
  </a-card>
  <a-modal  :keyboard="false" title="企业营业执照资质" :width='800' centered :footer="null" v-model:visible="visibleZz"
    destroyOnClose>
    <licence v-on:onsubmit='onsubmitLicense' :formData='formData'></licence>
  </a-modal>
  <a-modal  :keyboard="false" title="中国商标权证书资质" :width='800' centered :footer="null" v-model:visible="visibleZs"
    destroyOnClose>
    <certificate v-on:onsubmit='onsubmitTrademark' :formData='formData'></certificate>
  </a-modal>
</template>
<script>
import { ref, onMounted, reactive, toRefs } from 'vue';
import { message } from 'ant-design-vue';
import { getRouter } from '@/utils/app';
import { getCertList,setLicenseUpdate,setTrademarkUpdate } from '@/api/system';
import { getPayList } from '@/api/system';
import { iscode } from '@/utils/app';
import certificate from './components/certificate';
import licence from './components/licence';
export default {
  components: { certificate,licence },
  setup(props) {
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      formData:{},
      listLoading: false,
      valueRadio: null,
      visibleZz:false,
      visibleZs:false
    });
    let columns = [
      {
        title: '资质名称',
        dataIndex: 'cert_name',
        key: 'cert_name',
      },
      {
        title: '状态',
        dataIndex: 'status_text',
        key: 'status_text',
      },
      {
        title: '说明',
        dataIndex: 'desc',
        key: 'desc',
      },
      {
        title: '操作',
        width:150,
        align:'center',
        key: 'action',
        slots: { customRender: 'action' },
      },
    ];
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getCertList(values).then(res=>res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    const submit = (e) => {
      state.formData = {status:e.status,status_text:e.status_text}
      if(e.cert_type == 1){
        state.visibleZz = true
      }else{
        state.visibleZs = true
      }
    };
    const update  = (e) => {
      state.formData = e
      if(e.cert_type == 1){
        state.visibleZz = true
      }else{
        state.visibleZs = true
      }
    };
    //企业营业执照修改
    const onsubmitLicense = async(e) =>{
      const hide = message.loading('正在加载中...', 0);
      let res = await setLicenseUpdate(e).then(res=>res.data);
      if (iscode(res, true)) {
        initData();
        state.visibleZz = false
      }
      setTimeout(hide);
    }
    //中国商标权证书修改
    const onsubmitTrademark = async(e) =>{
      const hide = message.loading('正在加载中...', 0);
      let res = await setTrademarkUpdate(e).then(res=>res.data);
      if (iscode(res, true)) {
        initData();
        state.visibleZs = false
      }
      setTimeout(hide);
    }
    onMounted(() => {
      initData();
    });
    return {
      ...toRefs(state),
      data,
      columns,
      update,
      submit,
      onsubmitLicense,
      onsubmitTrademark
    };
  },
};
</script>